import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { NotFoundComponent } from './not-found/not-found.component';
import { UnderconstructionComponent } from './underconstruction/underconstruction.component';
// import { TokenDetailsComponent } from './token-details/token-details.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
  },
  {
    path: 'login',
    loadChildren: () => import('./authentication/login/login.module').then(m => m.LoginModule),
  },

  {
    path: 'register',
    loadChildren: () => import('./authentication/register/register.module').then(m => m.RegisterModule),
  },
  {
    path: 'register/:id',
    loadChildren: () => import('./authentication/register/register.module').then(m => m.RegisterModule),
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./authentication/forgetpassword/forgetpassword.module').then(m => m.ForgetPasswordModule),
  },
  {
    path: 'security-verification',
    loadChildren: () => import('./authentication/security-verification/security-verification.module').then(m => m.SecurityVerificationModule),
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./authentication/resetpassword/resetpassword.module').then(m => m.ResetPasswordModule),
  },
  {
    path: 'reset-security',
    loadChildren: () => import('./authentication/reset-security/reset-security.module').then(m => m.ResetSecurityModule),
  },
  {
    path: 'aboutus',
    loadChildren: () => import('./staticpages/aboutus/aboutus.module').then(m => m.AboutusModule),
  },
  {
    path: 'blog',
    loadChildren: () => import('./staticpages/newblog/newblog.module').then(m => m.NewblogModule),
  },
  {
    path: 'blog-details/:Title',
    loadChildren: () => import('./staticpages/newblog-details/newblog-details.module').then(m => m.NewblogDetailsModule)
  },
  {
    path: 'risk-policy',
    loadChildren: () => import('./staticpages/risk-policy/risk-policy.module').then(m => m.RiskPolicyModule),
  },
  {
    path: 'withdrawal-policy',
    loadChildren: () => import('./staticpages/withdrawal-policy/withdrawal-policy.module').then(m => m.WithdrawalPolicyModule),
  },
  {
    path: 'kyc-policy',
    loadChildren: () => import('./staticpages/kyc/kyc.module').then(m => m.KycModule),
  },
  {
    path: 'swap',
    loadChildren: () => import('./swap/swap.module').then(m => m.SwapModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'referral-program',
    loadChildren: () => import('./staticpages/referral-program/referral-program.module').then(m => m.ReferralProgramModule),
  },
  // {
  //   path: 'fees',
  //   loadChildren: () => import('./staticpages/fees-schedule/fees-schedule.module').then(m => m.FeesModule),
  // },
  {
    path: 'fees',
    loadChildren: () => import('./staticpages/fees-structure/fees-structure.module').then(m => m.FeesStructureModule),
  },
  // {
  //   path: 'fees1',
  //   loadChildren: () => import('./staticpages/fees-schedule/fees-schedule.module').then(m => m.FeesModule),
  // },
  {
    path: 'support',
    loadChildren: () => import('./staticpages/supportpage/supportpage.module').then(m => m.SupportpageModule),
  },


  {
    path: 'otc',
    loadChildren: () => import('./otctrade/otctrade.module').then(m => m.OtctradeModule),
  },


  {
    path: 'faqs',
    loadChildren: () => import('./staticpages/faqs/faqs.module').then(m => m.FaqsModule),
  },
  {
    path: 'assets-listing',
    loadChildren: () => import('./staticpages/tokenlisting/tokenlisting.module').then(m => m.TokenListingModule),

  },
  {
    path: 'p2pnotification',
    loadChildren: () => import('./notification/notification.module').then(m => m.NotificationModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'p2p',
    loadChildren: () => import('./p2p/p2p-main/p2p-main.module').then(m => m.P2pMainModule),
    canActivate: [AuthGuard]

  },

  {
    path: 'assets-view',
    loadChildren: () => import('./staticpages/tokenlistdetails/tokenlistdetails.module').then(m => m.TokenlistdetailsModule),
  },
  {
    path: 'terms-conditions',
    loadChildren: () => import('./staticpages/terms/terms.module').then(m => m.TermsModule),
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./staticpages/privacy-policy/privacy-policy.module').then(m => m.PrivacypolicyModule),
  },
  {
    path: 'airdrop',
    loadChildren: () => import('./staticpages/law-enforcement/law-enforcement.module').then(m => m.LawEnforcementModule),
  },
  {
    path: 'refund-policy',
    loadChildren: () => import('./staticpages/compliance-disclosure/compliance-disclosure.module').then(m => m.ComplianceDisclosureModule),
  },
  {
    path: 'markets',
    loadChildren: () => import('./markets/markets.module').then(m => m.MarketsModule),
  },
  {
    path: 'notification',
    loadChildren: () => import('./notification/notification.module').then(m => m.NotificationModule),
    canActivate: [AuthGuard]
  },

  {
    path: 'user',
    loadChildren: () => import('./usermodule/usermodule.module').then(m => m.UserModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'chart',
    loadChildren: () => import('./trade-chart/trade-chart.module').then(m => m.TradeChartModule),
  },
  {
    path: 'chart/:theme',
    loadChildren: () => import('./trade-chart/trade-chart.module').then(m => m.TradeChartModule),
  },
  {
    path: 'trade-page/:id',
    loadChildren: () => import('./trade-page/trade-page.module').then(m => m.TradePageModule),
  },
  {
    path: 'trade',
    loadChildren: () => import('./trade/trade.module').then(m => m.TradeModule),
  },

  {
    path: 'user-support',
    loadChildren: () => import('./usermodule/support/support.module').then(m => m.SupportModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'buy-kait',
    loadChildren: () => import('./instant-buy/instant-buy.module').then(m => m.InstantBuyModule),
  },


  {
    path: 'referral',
    loadChildren: () => import('./referral/referral.module').then(m => m.ReferralModule),
    canActivate: [AuthGuard]
  },
  //  {
  //   path: 'announcement',
  //   loadChildren: () => import('./cms/announcement/announcement.module').then(m => m.AnnouncementModule),
  // },
  // {
  //   path: 'announcement-latest',
  //   loadChildren: () => import('./cms/announce-lastest/announce-lastest.module').then(m => m.AnnounceLastestModule),
  // },

  // {
  //   path: 'announcement-update',
  //   loadChildren: () => import('./cms/announce-update/announce-update.module').then(m => m.AnnounceUpdateModule),
  // },
  // {
  //   path: 'announcement-update/:id',
  //   loadChildren: () => import('./cms/announce-update/announce-update.module').then(m => m.AnnounceUpdateModule),
  // },
  // {
  //   path: 'announce-career',
  //   loadChildren: () => import('./cms/announce-career/announce-career.module').then(m => m.AnnounceCareerModule),
  // },
  // {
  //   path: 'career-form',
  //   loadChildren: () => import('./cms/career-form/career-form.module').then(m => m.CareerFormModule),
  // },
  // {
  //   path: 'career-form-details',
  //   loadChildren: () => import('./cms/career-form-details/career-form-details.module').then(m => m.CareerFormDetailsModule),
  // },
  // {
  //   path: 'career-form-data',
  //   loadChildren: () => import('./cms/career-form-data/career-form-data.module').then(m => m.CareerFormDataModule),
  // },
  // {
  //   path: 'carrer-community',
  //   loadChildren: () => import('./cms/community/community.module').then(m => m.CommunityModule),
  // },
  {
    path: 'sep',
    loadChildren: () => import('./sep/sep.module').then(m => m.SepModule),
  },
  { path: '', redirectTo: '/', pathMatch: 'full' },
  { path: 'under-construction', component: UnderconstructionComponent },
  { path: '404', component: NotFoundComponent },
  { path: '**', redirectTo: '404' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
